














































































































































import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// components
import { Input, Select, Radio } from '@/components/form'

// constants
import { optionsTypeOfContract, optionsWorkCategory, optionsStatusEmployee, optionsWorkType } from '@/constants'

// services
import { PositionService, HeadquarterService, AreaService } from '@/services/config'

// models
import { Position, FilterEmployeeModel, HeadquarterModel, AreaModel } from '@/models/config'

export default defineComponent({
  name: 'FiltersEmployees',
  components: {
    Input,
    Select,
    Radio
  },
  setup () {
    const filters: Ref<FilterEmployeeModel> = ref({
      name: '',
      position: null,
      workCategory: null,
      typeContract: null,
      headquarters: null,
      area: null,
      subArea: null,
      workType: null,
      status: true
    })

    const positions: Ref<Position[]> = ref([])
    const headquarters: Ref<HeadquarterModel[]> = ref([])
    const areas: Ref<AreaModel[]> = ref([])
    const getAllParameters = async () => {
      positions.value = await PositionService.getAllActivated()
      headquarters.value = await HeadquarterService.getAllActivate()
      areas.value = await AreaService.getActivated()
    }
    getAllParameters()

    const optionsPositions = computed(() => {
      return [
        {
          value: null,
          text: '-- Ninguno --'
        }, ...positions.value.map(p => {
        return {
          value: Number(p.id),
          text: p.name
        }
      })]
    })

    const headquarterOp = computed(() => {
      return [
        {
          value: null,
          text: '-- Ninguno --'
        },
        ...headquarters.value.map(h => {
        return {
          value: Number(h.id),
          text: h.name
        }
      })]
    })

    const areasOp = computed(() => {
      return [
        {
          value: null,
          text: '-- Ninguno --'
        },
        ...areas.value.map(a => {
        return {
          value: Number(a.id),
          text: a.name
        }
      })]
    })

    const subAreasOp = computed(() => {
      if (filters.value.area) {
        const area = areas.value.find(a => a.id === filters.value.area)
        if (area?.subAreas) {
          return [
            {
              value: null,
              text: '-- Ninguno --'
            },
            ...area.subAreas?.map(sub => {
                return {
                  value: Number(sub.id),
                  text: sub.name
                }
              })
          ]
        }
      }
      return []
    })

    const cleanFilters = () => {
      filters.value = {
        name: '',
        position: null,
        workCategory: null,
        typeContract: null,
        headquarters: null,
        area: null,
        subArea: null,
        workType: null,
        status: true
      }
    }

    const opTypeOfContract = [
      {
        value: null,
        text: '-- Ninguno --'
      },
      ...optionsTypeOfContract
    ]
    const opWorkCategory = [
      {
        value: null,
        text: '-- Ninguno --'
      },
      ...optionsWorkCategory
    ]
    const opWorkType = [
      {
        value: null,
        text: '-- Ninguno --'
      },
      ...optionsWorkType
    ]

    return {
      filters,
      opTypeOfContract,
      opWorkCategory,
      optionsStatusEmployee,
      optionsPositions,
      cleanFilters,
      opWorkType,
      headquarterOp,
      areasOp,
      subAreasOp
    }
  }
})
